import Checkbox from '@atlaskit/checkbox';
import { Box } from '@atlaskit/primitives';
import { useFlaggingCallback } from '@databases/banners';
import { useBooleanFeatureFlag } from '@databases/feature-flags/hooks';
import { ViewComponentProps } from '@databases/fields/view/types';
import { defaultStoreUtils } from '@databases/redux';
import { addChangeToDraft } from '@databases/redux/changesets/actions';
import { DatabaseFieldType } from '@databases/types/database';
import { DatabaseChangeType } from '@databases/types/redux';
import { FunctionComponent, useState } from 'react';
import React from 'react';

const CheckboxValueEdit: FunctionComponent<
  ViewComponentProps<DatabaseFieldType.CHECKBOX>
> = ({ field, contentId, value, entryId }) => {
  const dispatch = defaultStoreUtils.useDispatch();
  const [isChecked, setIsChecked] = useState(value);
  const isCheckboxEnabled = useBooleanFeatureFlag(
    'databases-frontend-checkbox-field-type'
  );
  const toggleCheckbox = useFlaggingCallback(async () => {
    await dispatch(
      addChangeToDraft(contentId, 'main', {
        type: DatabaseChangeType.SET_VALUE,
        fieldId: field.id,
        entryId: entryId as string,
        value: {
          type: DatabaseFieldType.CHECKBOX,
          value: !isChecked,
        },
        change: {
          type: DatabaseFieldType.CHECKBOX,
          value: !isChecked,
        },
      })
    );
    {
      setIsChecked(!isChecked);
    }
  }, [contentId, dispatch, entryId, field.id, isChecked]);
  // if checkbox ff is off, disable checkboxes
  if (!isCheckboxEnabled) {
    return (
      <Box padding="space.025">
        <Checkbox
          isChecked={isChecked}
          onChange={toggleCheckbox}
          isDisabled={true}
          size="large"
        ></Checkbox>
      </Box>
    );
  }
  return (
    <Box padding="space.025">
      <Checkbox isChecked={isChecked} onChange={toggleCheckbox} size="large"></Checkbox>
    </Box>
  );
};
export default CheckboxValueEdit;
